import React from 'react';
import { CardMedia } from '@material-ui/core';
import useStyles from './ImagePreview.styles';

interface IProps {
  src: string;
}

const ImagePreview: React.FC<IProps> = ({ src }) => {
  const styles = useStyles();

  return <CardMedia src={src} component="img" alt={'no img'} className={styles.imageLabel} />;
};

export default ImagePreview;
